import WorkerTableView from "../../Components/Forms/WorkerTableView"
const WorkerTablePage = () => {
    return (
            <WorkerTableView/>
    );
};

export default WorkerTablePage;